export default "__VITE_ASSET__DGgrqyJ8__"